import React, { Component } from 'react'
import { Route, Switch, BrowserRouter as Router } from 'react-router-dom'
import moment from 'moment'

import InvitePage from './invite'
import { Base64 } from 'js-base64'
import queryString from 'query-string'
import ErrorPage from '../error/error'
import FetchWrapper from '../../utils/fetch_wrapper'

import config from './../../utils/config'

class Invite extends Component {
  constructor(props) {
    super(props)
    this.state = {
      data: null,
      loading: true
    }
    document.title = "Newtopia"
  }

  async componentDidMount() {
    const response = await this.getInviteConfig()
    if (!response) {
      //this.props.error()
    } else {
      this.setState({ loading: false })
    }
  }

  errorPage() {
    return (
      <ErrorPage />
    )
  }

  extendRoute(R, props) {
    if (!this.state.data) return null
    return (
      <R 
        {...props}
        startTime = {this.state.data.Events[0].startTime ? moment(this.state.data.Events[0].startTime) : undefined}
      />
    )
  }

  async getInviteConfig() {
    let queryParams = `&eventId=${Base64.decode(queryString.parse(this.props.location.search).event)}`
    try { 
      let response = await FetchWrapper.fetch(config.endpoint_getEvents_public + queryParams, {
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
      })
      const { data } = response
      this.setState({ data })
      return response.data.Events
    } catch (error) {
      return null
    }

  }

  render() {
    if (this.state.loading) return <div></div>
    return (
      <div id="invite">
        <Router basename={this.props.match.path}>
          <Switch>
            <Route path="/" render={props => this.extendRoute(InvitePage, props)} />
          </Switch>
        </Router>
      </div>
    )
  }
}

export default Invite
